import { apiBaseUrl, spevalApi } from 'yxt-biz-pc/packages/api';

let baseUrl = apiBaseUrl;

let apiTalent = 'sptalent';
let apiTalentsd = 'sptalentsd';

spevalApi.defaults.headers['x-yxt-product'] = 'sp';

// 获取评估方案详情
export const getEvalInfo = (evaluationId) => {
  return spevalApi.get(`/mgr/evaluations/${evaluationId}`);
};
// 保存评估方案配置详情
export const postEvalConfigs = (evaluationId, data) => {
  return spevalApi.post(`/mgr/evaluations/${evaluationId}/configs`, data);
};
// 岗位地图-测评管理-测评绑定岗位
export const EvalBindPosition = (data) => {
  return baseUrl.post(`${apiTalent}/mgr/postmap/bindeval`, data);
};
// 获取发布评估方案通知详情
export const getPublishEval = (evaluationId) => {
  return spevalApi.get(`/mgr/evaluations/${evaluationId}/notify`);
};
// 发布评估方案
export const publishEval = (evaluationId, data) => {
  return spevalApi.post(`/mgr/evaluations/${evaluationId}/notify`, data);
};
// 导入评估关系
export const importEvalRelation = (data, targetId) => {
  return spevalApi.post(`/mgr/evaluationusers/import/${targetId}`, data);
};
// 根据导出的模板，导入第三方评估数据
export const thirdImportPerson = (data, evaluationId) => {
  return spevalApi.post(`/mgr/evaluationusers/${evaluationId}/resultimport`, data);
};
// 获取评估关系
export const getEvalRelations = (evaluationId) => {
  return spevalApi.get(`/mgr/evaluationusers/${evaluationId}/evalusers`);
};
// 获取全部人员
export const getEvalsimpleusers = (evaluationId) => {
  return spevalApi.get(`/mgr/evaluationusers/${evaluationId}/evalsimpleusers`);
};
// 分页获取评估关系
export const getEvalRelationsPage = (evaluationId, params) => {
  return spevalApi.get(`/mgr/evaluationusers/${evaluationId}/evalusersforpage`, params);
};
// 初始化选择的被评估人评估关系
export const addEvalTarget = (evaluationId, data) => {
  return spevalApi.post(`/mgr/evaluationusers/${evaluationId}/chosenusers`, data);
};
// 获取评估方案配置详情
export const getEvalConfigs = (evaluationId) => {
  return spevalApi.get(`/mgr/evaluations/${evaluationId}/configs`);
};

// 设置评估关系-创建测评方案
export const postEvalRelationscheme = (evaluationId, data) => {
  return spevalApi.post(`/mgr/evaluationusers/${evaluationId}/evalusersDelete`, data);
};

export const GetEvalPositionUsers = (body, params) => {
  return baseUrl.post(`${apiTalent}/mgr/postmap/chooseuser`, body, { params: params });
};
// 保存评估方案详情
export const postEvalInfo = (data) => {
  return spevalApi.post('/mgr/evaluations', data);
};

// 获取测评工具
export const getEvalUtils = data => {
  return spevalApi.get('/mgr/survey/selectEvalSurvey', data);
};

// 保存评估方案
export const saveEval = data => {
  return spevalApi.post('/mgr/evaluations/saveEvaluation', data);
};

// 获取问卷
export const getSurveyById = (id) => {
  return spevalApi.get(`/mgr/survey/search/${id}`);
};

// 获取方案信息
export const getEvalData = id => {
  return spevalApi.get(`/mgr/evaluations/${id}`);
};

// 根据模型id获取能力详情
export const getModelById = id => {
  return baseUrl.get(`${apiTalentsd}/mgr/model/skillmodel/${id}`);
};

export const getDataPermission = () => {
  return baseUrl.get(`${apiTalent}/mgr/orgs/getdatapermission`);
};

// 选人组件批量加人
export const userChooseAdd = (id, data) => {
  return spevalApi.post(`/mgr/evaluationusers/${id}/chooseAdd`, data);
};

// 选人组件批量删除
export const userChooseDelete = (id, data) => {
  return spevalApi.post(`/mgr/evaluationusers/${id}/chooseDelete`, data);
};
// 同步评估关系
export const syncEvalRelation = data => {
  return spevalApi.post('/mgr/mubes/syncuser', data);
};

// 同步评估关系进度查询
export const getSyncEvalRelationProgress = data => {
  return spevalApi.post('/mgr/mubes/syncuser/progress', data);
};

// 获取所有自定义和默认的评估关系列表
export const getFormRelationList = (serviceId) => {
  return spevalApi.get(`/eval/setting/custom/list?serviceId=${serviceId}`);
};

// 根据前测和后测的id，绑定关系和复制评估关系
export const postAfterEvaluation = (params) => {
  return spevalApi.post('mgr/evaluations/components/arrange/after/evaluation', params);
};
